import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ListChecksIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M4.63,8h0A.9.9,0,0,1,4,7.72L2.77,6.48A.87.87,0,0,1,4,5.24l.63.62L6.52,4A.87.87,0,0,1,7.76,5.2L5.25,7.72A.91.91,0,0,1,4.63,8Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.63,14h0A.9.9,0,0,1,4,13.72L2.77,12.48A.87.87,0,1,1,4,11.24l.63.62L6.52,10A.87.87,0,0,1,7.76,11.2L5.25,13.72A.91.91,0,0,1,4.63,14Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.63,20h0A.9.9,0,0,1,4,19.72L2.77,18.48A.87.87,0,0,1,4,17.24l.63.62L6.52,16A.87.87,0,0,1,7.76,17.2L5.25,19.72A.91.91,0,0,1,4.63,20Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.5,19H20a1,1,0,0,0,0-2H10.5a1,1,0,0,0,0,2Zm0-6H20a1,1,0,0,0,0-2H10.5a1,1,0,0,0,0,2Zm-1-7a1,1,0,0,0,1,1H20a1,1,0,0,0,0-2H10.5A1,1,0,0,0,9.5,6Z"
  })]
}), 'ListChecksIcon');